import classnames from 'classnames'
import ActivityLoader from 'react-loaders'
import PropTypes from 'prop-types'

import classes from './Loader.module.scss'
import styles from '../../../assets/styles/globals.scss'

// Note: Don't forget to import the loader type in index.scss
const Loader = ({ children, loaderType = 'ball-pulse', loaderColor = styles.loaderAnimationGray }) => (
  <div className='d-flex flex-column align-items-center justify-content-center'>
    <ActivityLoader type={loaderType} color={loaderColor} active />
    <span
      id='loaderText'
      className={classnames('mt-3', classes.text)}
    >
      {children}
    </span>
  </div>
)

Loader.propTypes = {
  children: PropTypes.node,
  loaderType: PropTypes.string,
  loaderColor: PropTypes.string,
}

export default Loader
